import React, { Fragment, ReactElement, useEffect } from 'react';
import { Grid2, Paper, Container, Typography, Box, Backdrop, CircularProgress, Button } from '@mui/material';
import { importSites } from '../../redux/actions/siteActions';
import { useAppDispatch, useAppSelector } from '../../hooks/hooks';
import { RootState } from '../../redux/reducers';
import { importAllGoods } from '../../redux/actions/goodsActions';
import { importArticles } from '../../redux/actions/articleActions';
import { importClients } from '../../redux/actions/clientActions';
import { importPurchaseOrders } from '../../redux/actions/purchaseOrderActions';
import { useNavigate } from 'react-router-dom';

export default function Dashboard(): ReactElement {
    const sites = useAppSelector((state: RootState) => state.sites.sites);
    const goods = useAppSelector((state: RootState) => state.goods.goods);
    const articles = useAppSelector((state: RootState) => state.articles.articles);
    const clients = useAppSelector((state: RootState) => state.clients.clients);
    const purchaseOrders = useAppSelector((state: RootState) => state.purchaseOrders.purchaseOrders);

    const dispatch = useAppDispatch();

    const navigate = useNavigate();

    useEffect(() => {
        if (!sites) {
            dispatch(importSites());
        }
    }, [dispatch]);

    useEffect(() => {
        if (!goods) {
            dispatch(importAllGoods());
        }
    }, [dispatch]);

    useEffect(() => {
        if (!articles) {
            dispatch(importArticles());
        }
    }, [dispatch]);

    useEffect(() => {
        if (!clients) {
            dispatch(importClients());
        }
    }, [dispatch]);

    useEffect(() => {
        if (!purchaseOrders) {
            dispatch(importPurchaseOrders());
        }
    }, [dispatch]);

    return !clients || !articles || !goods || !sites ? (
        <Fragment>
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={!Boolean(articles) || !Boolean(goods) || !Boolean(sites) || !Boolean(clients)}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </Fragment>
    ) : (
        <div>
            <Container maxWidth={false} sx={{ mt: 4, mb: 4 }}>
                <Grid2 container spacing={3}>
                    <Grid2 size={{ xs: 12, md: 6 }}>
                        <Button
                            variant="outlined"
                            sx={{ width: '100%', height: 70, fontSize: 25 }}
                            onClick={() => navigate('/constructionSites')}
                        >
                            Gradilišta
                        </Button>
                    </Grid2>
                    <Grid2 size={{ xs: 12, md: 6 }}>
                        <Button
                            variant="outlined"
                            sx={{ width: '100%', height: 70, fontSize: 25 }}
                            onClick={() => navigate('/warehouses')}
                        >
                            Magacini
                        </Button>
                    </Grid2>
                    <Grid2 size={{ xs: 12 }}>
                        <Button
                            variant="outlined"
                            sx={{ width: '100%', height: 150, fontSize: 25 }}
                            onClick={() => navigate('/goods')}
                        >
                            Roba
                        </Button>
                    </Grid2>
                    {/* <Grid2 size={{ xs: 12 }}>
                        <Button
                            variant="outlined"
                            sx={{ width: '100%', height: 250, fontSize: 25 }}
                            onClick={() => navigate('/orders')}
                        >
                            Nalozi
                        </Button>
                    </Grid2> */}
                </Grid2>
            </Container>
        </div>
    );
}
